import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAgahFundIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={40} height={40} fill='none' {...props}>
    <rect width={40} height={40} fill='#9575CD' rx={8} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M17 30h6c5 0 7-2 7-7v-6c0-5-2-7-7-7h-6c-5 0-7 2-7 7v6c0 5 2 7 7 7'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M16 27h8q3 0 3-3v-8q0-3-3-3h-8q-3 0-3 3v8q0 3 3 3'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M13 17.5h2.48a2.5 2.5 0 0 1 0 5H13M27 17.99h-3M27 22h-3'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={2}
      d='M15.2 20h.1'
    />
  </svg>
);
export default SvgAgahFundIcon;
